import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCreditCard2"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V9H22V4ZM2 20V11H22V20H2ZM6 13V15H11V13H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCard2;
